import { TableProvider } from "./provider";
import { MainComponent } from "./components";

export function ListPage() {
  return (
    <TableProvider>
      <MainComponent />
    </TableProvider>
  );
}
